import { ModelSagres } from "../model-sagres";

export class Destinatario extends ModelSagres {
  nomeDestinatario: string;
  tipoDestinatario: string;

  constructor(obj?: any) {
    super();
    if (obj) {
      this.nomeDestinatario = obj.nomeDestinatario;
      this.tipoDestinatario = obj.tipoDestinatario;
    }
  }
}
